import { render } from "./consequence.vue?vue&type=template&id=67db2712&scoped=true"
import script from "./consequence.vue?vue&type=script&lang=js"
export * from "./consequence.vue?vue&type=script&lang=js"

import "./consequence.vue?vue&type=style&index=0&id=67db2712&lang=scss&scoped=true"
import "./consequence.vue?vue&type=style&index=1&id=67db2712&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67db2712"]])

export default __exports__